import {
  StagingAccountApi,
  type Configuration,
  type StagingAccountConfig,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

export const stagingAccount = (
  httpClient: HttpClient,
  config: Configuration
) => {
  const api = new StagingAccountApi(config);
  return {
    useAccount: () =>
      httpClient.execute(
        api.getStagingAccount.bind(api),
        '/staging-account',
        ''
      ),
    setAccount: (body: StagingAccountConfig) => api.setStagingAccount(body),
  };
};
